<template>
  <section>
    <div class="sp-title">付款申请</div>
    <div class="sp-nav"><span class="sp-nav-item">商务管理</span><span class="sp-nav-item-sple">/</span><span class="sp-nav-item">付款申请</span><span class="sp-nav-item-sple">/</span><span class="sp-nav-item">业务成本付款申请</span></div>
    <el-form :inline="true" :model="queryForm" class="query-form demo-form-inline">
      <div class="input-box1">
        <div style="width:200px;">
          <div style="font-size:14px;margin-top:15px;color:#7E7E7E;">收款方简称</div>
          <el-form-item>
            <el-input v-model="queryForm.simpleName" placeholder="简称"  clearable></el-input>
          </el-form-item>
        </div>
        <div style="width:500px;margin-left: 60px;">
          <div style="font-size:14px;margin-top:15px;color:#7E7E7E;">是否已开发票：</div>
          <el-form-item>
            <el-radio-group style="padding-top: 5px;">
              <el-tag :type="queryForm.billType==1?'success':'info'" style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;" @click="selectBillType(1)">专票</el-tag>
              <el-tag :type="queryForm.billType==2?'success':'info'" style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;" @click="selectBillType(2)">普票</el-tag>
            </el-radio-group>
          </el-form-item>
        </div>
      </div>
      <div class="input-box1">
        <div style="width:200px;">
          <div style="font-size:14px;color:#7E7E7E;">船舶名称：</div>
          <el-form-item>
            <el-input v-model="queryForm.shipName" placeholder="船舶名称"  clearable></el-input>
          </el-form-item>
        </div>
        <div style="width:500px;margin-left: 60px">
          <div style="font-size:14px;color:#7E7E7E;">合同公司：</div>
          <el-form-item>
            <el-radio-group v-model="queryForm.invoiceCompany" style="padding-top: 5px;">
              <el-tag style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;" :type="queryForm.invoiceCompany==item.code?'success':'info'"
                      v-for="(item,index) in  contractCompanyList" :key="index" @click="leixingadd(item)"
              >{{item.value}}</el-tag>
            </el-radio-group>
          </el-form-item>
        </div>
        <div style="width:500px;margin-left: 60px;">
          <div style="font-size:14px;color:#7E7E7E;">核算：</div>
          <el-form-item>
            <el-tag v-for="(item,index) in accountList" :key="index"
                    :type="queryForm.accountType==item.value?'success':'info'"
                    style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;"
                    @click="selectAccountType(item.value)">{{item.label}}</el-tag>
          </el-form-item>
        </div>
        <div style="margin-left: 30px; text-align:left;width:330px;">
          <el-form-item style="margin-top:20px;">
            <el-button v-if="$store.getters.fandianCar.goods.length > 0" @click="carVisable = true" plain>购物车</el-button>
            <el-button @click="pageNo = 1;onQuery()" type="primary" >查询</el-button>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <template>
      <el-table
        class="el-table-info mytable"
        :data="tableData"
        stripe
        style="width: 100%"
        :show-overflow-tooltip="true"
        border
        v-loading="tableLoading"
      >
        <el-table-column
          :formatter="publicFmt"
          prop="oneCustomerName"
          label="一级客户简称"
          width="120"
          key="4">
        </el-table-column>
        <el-table-column
          :formatter="publicFmt"
          prop="customerName"
          label="二级客户简称"
          width="120"
          key="5">
        </el-table-column>
        <el-table-column
          :formatter="publicFmt"
          prop="shipNameStr"
          label="船舶名称"
          width="200">
        </el-table-column>
        <el-table-column
          :formatter="publicFmt"
          prop="costTypeName"
          label="费种"
          width="90">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="totalReceive"
          label="应付总额"
          width="120">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="billUnReceive"
          label="已开未付"
          width="120">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="arrearsAmount"
          label="欠票金额"
          width="120">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="noBillUnReceive"
          label="无票未付"
          width="120">
        </el-table-column>
        <el-table-column
          :formatter="publicFmt"
          prop="businessUser"
          label="业务员"
          width="100">
        </el-table-column>
        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.isApply == null||scope.row.isApply == 0">
              <el-button @click="openShowApply(scope.row)" type="text" size="small">付款申请</el-button>
              <el-button @click="viewLxrRow(scope.row.customerId)" type="text" size="small">查看联系人</el-button>
            </div>
            <div v-if="scope.row.isApply == 1">
              <el-button class="change-color" type="text" size="small" style="cursor:not-allowed;">正在审批中</el-button>
              <el-button @click="viewLxrRow(scope.row.customerId)" type="text" size="small">查看联系人</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="pageNo"
        @current-change="eventPage"
        style="text-align: right;padding: 10px 0px;background-color: #fff"
      >
      </el-pagination>
    </template>

    <work-flow-component ref="processDrawer" @onCallback="getSpId" componentsWidth="80%" @onBeforeSubmit="onBeforeSubmit">
      <div slot="beforeFormSlot" style="position: relative;">
        <PaymentApprove :applyObj="applyObj" ref="paymentApprove"></PaymentApprove>
      </div>
    </work-flow-component>

    <el-dialog
      title="联系人信息"
      :visible.sync="isshowLxr"
      width="70%"
      :before-close="handleCloseLxr">

      <el-table
        height="300"
        :data="lxrlist">
        <el-table-column
          prop="name"
          :formatter="publicFmt"
          label="联系人"
          width="100">
        </el-table-column>
        <el-table-column
          prop="province"
          :formatter="publicFmt"
          label="省份"
          width="80">
        </el-table-column>
        <el-table-column
          prop="city"
          :formatter="publicFmt"
          label="城市"
          width="80">
        </el-table-column>
        <el-table-column
          prop="address"
          :formatter="publicFmt"
          label="地址"
          width="140">
        </el-table-column>
        <el-table-column
          width="100"
          :formatter="publicFmt"
          prop="accountName"
          label="户名">
        </el-table-column>

        <el-table-column
          width="140"
          :formatter="publicFmt"
          prop="cardNumber"
          label="卡号">
        </el-table-column>


        <el-table-column
          width="140"
          :formatter="publicFmt"
          prop="phone"
          label="固定电话">
        </el-table-column>


        <el-table-column
          prop="openingBank"
          :formatter="publicFmt"
          label="开户银行">
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="updateMod(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="removeMod(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </el-dialog>

    <el-dialog
      class="xuanxiang"
      :title="modLxr.id?'编辑联系人':'新增联系人'"
      :visible.sync="showAddmod"
      :before-close="handleClosemodLxr"
      :close-on-click-modal=false
    >
      <div style="margin: 0 5%;">
        <el-form
          class="query-form demo-form-inline myform"
          style="display: flex;"
          ref="addRef_lxr"
          :rules="rules"
          label-position="left"
          label-width="90px"
          :model="modLxr">
          <div class="sp_add_left">
            <el-form-item label="联系人" prop="name">
              <el-input placeholder="输入联系人"
                        v-model="modLxr.name"></el-input>
            </el-form-item>
            <el-form-item label="省份">
              <el-input placeholder="输入省份"
                        v-model="modLxr.province">
                <template slot="append">省</template>
              </el-input>
            </el-form-item>
            <el-form-item label="详细地址">
              <el-input placeholder="请输入详细地址"
                        v-model="modLxr.address"></el-input>
            </el-form-item>
            <el-form-item label="户名" prop="accountName">
              <el-input placeholder="请输入户名"
                        v-model="modLxr.accountName"></el-input>
            </el-form-item>

          </div>

          <div class="sp_add_right">
            <el-form-item label="电话">
              <el-input placeholder="输入电话"
                        v-model="modLxr.phone"></el-input>
            </el-form-item>
            <el-form-item label="城市">
              <el-input placeholder="输入城市"
                        v-model="modLxr.city">
                <template slot="append">市</template>
              </el-input>
            </el-form-item>
            <el-form-item label="开户银行" prop="openingBank">
              <el-input placeholder="输入开户银行"
                        v-model="modLxr.openingBank"></el-input>
            </el-form-item>
            <el-form-item label="卡号" prop="cardNumber">
              <el-input placeholder="输入卡号"
                        v-model="modLxr.cardNumber"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="savesuLxr">确 定</el-button>
          </span>
      </div>
    </el-dialog>

    <el-dialog
      class="xuanxiang"
      title="付款申请"
      :visible.sync="showApply"
      top="1vh"
      width="65%"
      :before-close="ApplyhandleClose"
      :close-on-click-modal=false
    >
      <el-form :inline="true" label-position="left" class="query-form demo-form-inline myform" :model="applicationForm" style="margin-left: 5%">
        <el-form-item label="合同公司:" label-width="90px">
          <el-radio-group v-model="applicationForm.invoiceCompany" style="padding-top: 5px;">
            <el-tag style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;" :type="applicationForm.invoiceCompany==item.code?'success':'info'"
                    v-for="(item,index) in  contractCompanyList" :key="index" @click="leixingaddIn(item)"
            >{{item.value}}</el-tag>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="确认状态:" label-width="90px">
          <el-radio-group style="padding-top: 5px;">
            <el-tag :type="applicationForm.isQueren==0?'success':'info'" style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;" @click="selectQueren(0)">已确认</el-tag>
            <el-tag :type="applicationForm.isQueren==1?'success':'info'" style="margin-right: 10px;margin-bottom: 10px;cursor: pointer;" @click="selectQueren(1)">未确认</el-tag>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="一级客户">
          <el-input disabled v-model="applicationForm.oneCustomerName"></el-input>
        </el-form-item>

        <el-form-item label="二级客户">
          <el-input disabled v-model="applicationForm.customerName"></el-input>
        </el-form-item>
      </el-form>


      <el-table
        :data="tabledata111"
        class="el-table-info"
        size="mini"
        height="40vh"
        stripe
        style="margin-left: 5%;width: 90%;"
        @cell-click="showMsg"
        :cell-class-name="setColumnClassName"
        @row-click="checkRow"
        v-loading="tableLoading2"
      >
        <el-table-column
          width="30"
          fixed>
          <template slot-scope="scope"><img :class="!scope.row.checked?'showpic':''" style="width: 14px;vertical-align: middle;" src="../assets/img/yixuanze.png"/></template>
        </el-table-column>
        <el-table-column
          :formatter="publicFmt"
          prop="shipName"
          label="船舶名称"
        >
        </el-table-column>
        <el-table-column
          :formatter="(row, column, cellValue, index) => { return myFmtDateTime(cellValue,'YYYY/MM/DD')}"
          prop="epartureTimeDate"
          label="离港日期"
          width="120">
        </el-table-column>
        <!-- <el-table-column
          :formatter="publicFmt"
          prop="kehu"
          label="客户"
          width="120">
          <template slot-scope="scope">
            {{scope.row.oneCustomerName}}{{scope.row.oneCustomerName?'/':''}}{{scope.row.customerName}}
          </template>
        </el-table-column> -->
        <el-table-column
          :formatter="NumFmt3"
          prop="settleTonnage"
          label="结算吨位"
          width="80">
        </el-table-column>
        <el-table-column
          :formatter="publicFmt"
          prop="priceWithTax"
          label="单价"
          width="50">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="surplus"
          label="应付金额"
          width="105"
        >
        </el-table-column>
        <el-table-column
          prop="hyfSurplus"
          width="105"
        >
          <template slot="header">
            <span>
              尚欠运费
              <el-tooltip placement="top-start" content="运费欠款不超过10元方可发起业务成本请款（该列数值小于等于10即可）">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </span>
          </template>
          <template slot-scope="scope">
            <el-tooltip placement="top-start">
              <div slot="content">总运费：{{round(scope.row.hyfTotal)}}<br/>已收：{{round(round(scope.row.hyfTotal) - round(scope.row.hyfSurplus))}}</div>
              <div :class="{ 'apply-shake': scope.row.shakeHyf }">{{round(scope.row.hyfSurplus)}}</div>
            </el-tooltip>



          </template>
        </el-table-column>

        <el-table-column
          :formatter="publicFmt"
          prop="priceSettlement"
          label="结算单价"
          width="80">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="settleAmount"
          label="结算金额"
          width="105"
        >
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="charge"
          label="剩余结算"
          width="105"
        >
        </el-table-column>
        <!--          <el-table-column-->
        <!--            label="合同是否审批通过"-->
        <!--            width="105"-->
        <!--          >-->
        <!--            <template slot-scope="scope">-->
        <!--              <span>{{scope.row.contractId && scope.row.contractSpStatus === 2 ? '是':'否'}}</span>-->
        <!--            </template>-->
        <!--          </el-table-column>-->
      </el-table>
      <div style="display:flex;width: 90%;margin: 10px 0;margin-left: 5%;" v-if="applicationForm.isQueren == 0">
        <div class="sp_add_left" style="display:flex;">
          <div style="width: 30%;line-height: 40px;">未付总金额:</div>
          <div style="width: 70%">
            <el-input v-model="applicationForm.amountPayable" placeholder="输入金额"  clearable disabled>
              <template slot="append">元</template>
            </el-input>
          </div>
        </div>
        <div class="sp_add_right" style="display:flex;">
          <div style="width: 40%;line-height: 40px;">本次结算总金额：</div>
          <div style="width: 60%">
            <el-input disabled v-model="applicationForm.payment" placeholder="请选择结算航次" clearable>
              <template slot="append">元</template>
            </el-input>
          </div>
        </div>
      </div>

      <div style="display:flex;width: 90%;margin: 10px 0;margin-left: 5%;" v-if="applicationForm.isQueren == 0">
        <div class="sp_add_left" style="display:flex; margin-right: 3px">
          <div style="width: 30%;line-height: 40px;">批量设单价：</div>
          <div style="width: 70%">
            <el-input v-model="applicationForm.priceBatch" placeholder="输入单价"  clearable>
              <template slot="append">元</template>
            </el-input>
          </div>
        </div>
        <div class="sp_add_right" style="display:flex;">
          <el-button type="text" @click="setPriceBatch()">批量设置</el-button>
        </div>
      </div>
      <div style="display:flex;width: 90%;margin: 10px 0;margin-left: 5%;" v-if="applicationForm.isQueren == 0">
        <div style="width: 13.5%;line-height: 40px;">收款账户：</div>
        <div style="margin-right: 5%;width: 50%;">
          <el-select v-model="applicationForm.contractId" placeholder="请选择" style="width: 100%" v-if="applicationForm.isQueren == 0">
            <el-option
              v-for="item in lxrlist"
              :key="item.id"
              :label="item.accountName"
              :value="item.id">
              <span style="float: left">{{item.accountName}}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{item.cardNumber}}</span>
            </el-option>
          </el-select>
        </div>
        <div>
          <el-button type="text" @click="addmod">为 {{applicationForm.customerName}} 添加一个账户</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button :disabled="!submitButtonEnable" plain @click="addCar" v-if="applicationForm.isQueren == 0">添加至购物车</el-button>
        <!-- 合同审批通过后才可以进行付款 -->
          <template v-if="submitButtonEnable">
            <el-button type="primary" :disabled="!submitButtonEnable" @click="applyVerify" v-if="applicationForm.isQueren == 0">提交</el-button>
          </template>
          <template v-else>
            <el-button disabled type="primary">提交</el-button>
            <!--            <el-tooltip  class="item" effect="dark" content="合同审批通过后才可以进行付款" placement="top">-->
            <!--              <i class="el-icon-question"></i>-->
            <!--            </el-tooltip>-->
          </template>
        </span>
    </el-dialog>


    <el-dialog
      title="购物车 （按收款人合并付款）"
      :visible.sync="carVisable"
      :close-on-click-modal="false"
      class="car-dialog"
      width="55%"
    >
      <el-alert
        title="刷新可清空购物车"
        :closable="false"
        type="warning"></el-alert>

      <el-descriptions class="car-accountinfo">
        <el-descriptions-item label="二级客户">{{$store.state.fandianCar.customerName.join(', ')}}</el-descriptions-item>
        <!-- <el-descriptions-item label="一级客户">{{$store.state.fandianCar.oneCustomerName.join(', ')}}</el-descriptions-item> -->
      </el-descriptions>

      <el-table
        :data="$store.state.fandianCar.goods"
        class="el-table-info"
        size="mini"
        stripe
      >
        <el-table-column
          :formatter="publicFmt"
          prop="shipName"
          label="船舶名称"
        >
        </el-table-column>
        <el-table-column
          :formatter="(row, column, cellValue, index) => { return myFmtDateTime(cellValue,'YYYY/MM/DD')}"
          prop="epartureTimeDate"
          label="离港日期"
          width="120">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt3"
          prop="settleTonnage"
          label="结算吨位"
          width="80">
        </el-table-column>
        <el-table-column
          :formatter="publicFmt"
          prop="priceWithTax"
          label="单价"
          width="80">
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="surplus"
          label="应付金额"
          width="105"
        >
        </el-table-column>
        <el-table-column
          :formatter="NumFmt"
          prop="settleAmount"
          label="结算金额"
          width="105"
        >
        </el-table-column>
        <el-table-column
          label="操作"
        >
          <template slot-scope="scope">
            <el-button @click="removeFromCar(scope.row, scope)" type="text" size="small">移出购物车</el-button></el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-descriptions class="car-accountinfo" v-if="$store.state.fandianCar.contact">
        <el-descriptions-item label="收款人">{{$store.state.fandianCar.contact.accountName}}</el-descriptions-item>
        <el-descriptions-item label="开户行">{{$store.state.fandianCar.contact.openingBank}}</el-descriptions-item>
        <el-descriptions-item label="卡号">{{$store.state.fandianCar.contact.cardNumber}}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="applyVerifyCar" >下一步（￥{{ $store.getters.fandianCarSumPrice }}）</el-button>
        </span>
    </el-dialog>
  </section>
</template>

<script>

import {ERR_OK,BASE_ACCOUNT_TYPE_LIST} from "../jslib/config";
import WorkFlowComponent from "../components/workflow/index";
import SimplePanelSelection from "../components/common/simplePanelSelection";
import dayjs from "dayjs";
import {getPaymentListfandian,getPaymentfandianListById} from "../api/costAggregation";
import {getDictionaryList} from "../api/sysdictionary";
import {getPersonalListById, savePersonalAccount,updatePersonalAccount,delPersonalAccount} from "../api/syscustomersecondlevelperson";
import {savePayment} from "../api/PaymentApply";
import PaymentApprove from "../components/approval/PaymentApprove";
import {fmtDictionary} from "../jslib/util";
import PanelSimpleSelection from "../components/common/panelSimpleSelection";

export default {
  data() {
    return {
      accountList: BASE_ACCOUNT_TYPE_LIST,
      carVisable: false,
      rules: {
        name: [
          {required: true, message: '请输入联系人名', trigger: 'blur'},
        ],
        accountName: [
          {required: true, message: '请输入账户名', trigger: 'blur'},
        ],
        openingBank: [
          {required: true, message: '请输入开户行', trigger: 'blur'},
        ],
        cardNumber: [
          {required: true, message: '请输入卡号', trigger: 'blur'},
        ],
      },
      queryForm:{
        accountType: 0,
        paymentType:null,
        paymentTypeName:null,
        billType:null,
        invoiceCompany:null,
        simpleName:null,
        shipName:null,
      },
      applicationForm:{
        isQueren:0,
        sysSupplierId:null,
        secondId:null,
        billType:null,
        invoiceCompany:null,
        routeName:null,
        additionalPrice:null,
        additionalRemark:null,
        contractId:null,
        customerName:null,
        priceBatch:null,
        oneCustomerName:null,
      },
      total:0,
      pageNo:1,
      pageSize:10,
      applyObj:{},
      tableLoading:true,
      tableLoading2:true,
      tableLoading3:true,
      dictionaryLists:[],
      tableData: [],
      showApply:false,
      isshowLxr:false,
      lxrlist:[],
      tabledata111:[],
      accountInfo:{},
      paymentTypeName:null,
      isShipPay:false,
      deductList:[],
      applyDeductData:[],
      costAggId:null,
      contractCompanyList:[],
      applyDataIds:[],
      shipPayShipOwner:null,
      showAddmod:false,
      modLxr:{},
      receiveCompany:[],

      submitButtonEnable: false,
    };
  },
  created() {
  },
  watch:{
    '$route' (to, from) {
      // 对路由变化作出响应
      this.initData()
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    selectAccountType(v) {
      // this.queryForm.accountType = v === this.queryForm.accountType ? null : v
      this.queryForm.accountType = v
    },
    removeFromCar(item, row){
      console.log(row, '--00=-=-=-=-');
      // 从this.$store.getters.fandianCar.goods里删除item
      this.$store.getters.fandianCar.goods.splice(this.$store.getters.fandianCar.goods.indexOf(item), 1);
    },
    addCar() {
      // if (this.applicationForm.contractId) {
      //   if (this.$store.getters.fandianCar.contact && this.$store.getters.fandianCar.contact.id && this.$store.getters.fandianCar.contact.id !== this.applicationForm.contractId) {
      //     this.$message({
      //       showClose: true,
      //       type: 'error',
      //       message: '收款账户与购物车内不一致'
      //     });
      //     return;
      //   }
      // }

      for (const selected of this.applyData) {
        if (this.$store.getters.fandianCar.goods.filter(s => s.id === selected.id).length > 0) {
          this.$message({
            showClose: true,
            type: 'error',
            message: `选中的航次【${selected.epartureTimeDate}/${selected.shipName}】与购物车内的航次存在重复`
          });
          return;
        }
      }

      if (this.applyData && this.applyData.length > 0) {
        this.$store.getters.fandianCar.goods = this.$store.getters.fandianCar.goods.concat(JSON.parse(JSON.stringify(this.applyData)));
        if (this.applicationForm.oneCustomerName && this.$store.getters.fandianCar.oneCustomerName.indexOf(this.applicationForm.oneCustomerName) < 0) {
          this.$store.getters.fandianCar.oneCustomerName.push(this.applicationForm.oneCustomerName);
        }
        if (this.applicationForm.customerName && this.$store.getters.fandianCar.customerName.indexOf(this.applicationForm.customerName) < 0) {
          this.$store.getters.fandianCar.customerName.push(this.applicationForm.customerName);
        }
      }


      if (this.applicationForm.contractId && this.applicationForm.contractId !== '') {
        for (const lxr of this.lxrlist) {
          if (this.applicationForm.contractId === lxr.id) {
            this.$store.getters.fandianCar.contact = JSON.parse(JSON.stringify(lxr));
            this.$store.getters.fandianCar.contact.secondId = this.applicationForm.secondId;
            break;
          }
        }
      }

      this.$message({
        showClose: true,
        type: 'success',
        message: '添加购物车成功'
      });
      return;
    },
    setPriceBatch() {
      console.log(this.applicationForm.priceBatch);
      this.applyData.forEach(item => {
        item.priceSettlement = this.applicationForm.priceBatch
        item.settleAmount = item.priceSettlement * item.settleTonnage
        this.calcAmount(this.applicationForm.priceBatch, item)
      });
    },
    addmod(){
      this.showAddmod = true
      this.modLxr = {
        name: '',
        province: '',
        address: '',
        accountName: '',
        city: '',
        openingBank: '',
        cardNumber: '',
        secondId : this.applicationForm.secondId
      }
    },
    updateMod(item) {
      this.showAddmod = true
      this.modLxr = JSON.parse(JSON.stringify(item))
      // console.log('this.modLxr', this.modLxr);
    },
    removeMod(item) {
      // 确认删除
      this.$confirm('确认删除该联系人？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delPersonalAccount(item.id).then(res => {
          if (res != null && res.resultCode === ERR_OK) {
            this.$message({
              showClose: true,
              type: 'success',
              message: '删除成功'
            });
            this.getLxrList(item.secondId)
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: res.data.msg
            });
          }
        })
      }).catch(() => {

      });
    },
    savesuLxr(){
      this.$refs["addRef_lxr"].validate((valid) => {
        if (valid) {
          // 修改
          if (this.modLxr.id) {
            updatePersonalAccount(this.modLxr).then(res => {
              if (res != null && res.resultCode === ERR_OK) {
                this.$message({
                  showClose: true,
                  type: 'success',
                  message: '修改成功'
                });
                this.getLxrList(this.modLxr.secondId)
                this.handleClosemodLxr()
              }

            })
          } else {
            // 保存
            savePersonalAccount(this.modLxr).then(res =>{
              if (res!=null&&res.resultCode === ERR_OK) {
                this.$message({
                  type: 'success',
                  message: '保存成功'
                });
                this.handleClosemodLxr()
                this.getLxrList(this.applicationForm.secondId)
              }
            })
          }


        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    handleClosemodLxr(){
      this.showAddmod = false
      this.modLxr = {
        name: '',
        province: '',
        address: '',
        accountName: '',
        city: '',
        openingBank: '',
        cardNumber: '',
        secondId : this.applicationForm.secondId
      }
    },
    initData(){
      this.applicationForm.routeName = this.$router.currentRoute.name
      this.queryForm={
        accountType: 0,
        isQueren:0,
        paymentType:null,
        paymentTypeName:null,
        billType:null,
        simpleName:null,
        shipName:null,
        invoiceCompany:25,
      }
      this.tableLoading = true
      getDictionaryList("contract_company,bill_tax").then(res=>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.dictionaryLists = res.map
          this.contractCompanyList = []
          for(var i=0;i<this.dictionaryLists["contract_company"].length;i++){
            if(this.dictionaryLists["contract_company"][i].code == 10 || this.dictionaryLists["contract_company"][i].code == 20 || this.dictionaryLists["contract_company"][i].code == 25){
              this.contractCompanyList.push(this.dictionaryLists["contract_company"][i])
            }
          }
        }
      }).finally(()=>{
        this.tableLoading = false
      });
      this.onQuery()
    },
    applyVerifyCar() {
      if (!this.$store.getters.fandianCar.contact || !this.$store.getters.fandianCar.contact.id) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '缺少收款账户'
        });
        return;
      }
      // let accountingTypes = this.$store.state.fandianCar.goods[0].accountingType;
      let accountingTypes = new Set();
      for(var i=0;i<this.$store.state.fandianCar.goods.length;i++){
        accountingTypes.add(this.$store.state.fandianCar.goods[i].accountingType)
      }
      // accountingTypes 2 不能和其他类型一起结算
      if ( accountingTypes.size > 1 && accountingTypes.has(1)) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '山东公司不能和其他类型一起结算'
        });
        return
      }

      // if (accountingTypes.size > 1) {
      //   this.$message({
      //     showClose: true,
      //     type: 'error',
      //     message: '山东公司和成功公司不能同时结算'
      //   });
      //   return
      // }
      console.log(accountingTypes.values().next().value, '// 0:成功  1:山东');

      this.applicationForm = {
        sysSupplierId:null,
        secondId:this.$store.getters.fandianCar.contact.secondId,
        payment:this.$store.getters.fandianCarSumPrice,
        remark:null,
        amountPayable:null,
        price:null,
        advanceBalance:null,
        invoiceCompany:this.queryForm.invoiceCompany,
        additionalPrice:null,
        additionalRemark:null,
        isQueren:0,
        routeName: this.$router.currentRoute.name,
        contractId:this.$store.getters.fandianCar.contact.id,
        customerName: this.$store.state.fandianCar.customerName.join(','),
        oneCustomerName: this.$store.state.fandianCar.oneCustomerName.join(','),
        priceBatch:null,
        accountingType: accountingTypes.values().next().value
      };
      this.applyData = this.$store.getters.fandianCar.goods
      let contractIds = []//[...new Set(this.applyData.map(item => item.contractId))]
      this.applyObj = {
        application: this.applicationForm,
        applylist: this.applyData,
        contact: this.$store.getters.fandianCar.contact,
        deductList: [],
        contractIds: contractIds.join(','),
        modelCode: 'fandian'
      }
      var shipName = this.applyData.map(item=>item.shipName).filter(function(item,index,arr){
        return arr.indexOf(item, 0) === index;
      }).join();
      this.$refs.processDrawer.title = '业务成本付款审批'
      this.$refs.processDrawer.drawer = true
      this.$nextTick(function () {
        this.$refs.paymentApprove.getData()
      })
      var payment = this.$store.getters.fandianCarSumPrice
      this.$refs.processDrawer.processCode = "paymentApprove"
      this.$refs.processDrawer.globalParams = {}
      this.$refs.processDrawer.globalParams.params2 = this.$store.getters.fandianCarGoodsIds.join(',')
      this.$refs.processDrawer.globalParams.params3 = parseFloat(Math.abs(payment).toFixed(2))
      this.$refs.processDrawer.globalParams.params4 = "1456194134325854211"
      this.$refs.processDrawer.globalParams.params5 = this.$store.state.fandianCar.oneCustomerName.join(',')
      this.$refs.processDrawer.globalParams.params6 = this.$store.state.fandianCar.customerName.join(',')
      this.$refs.processDrawer.globalParams.params7 = 'fandian'
      this.$refs.processDrawer.globalParams.params9 = contractIds.join(',')
      this.$refs.processDrawer.processName = "业务成本付款申请"
      this.$refs.processDrawer.briefContent = "收款公司："+this.$store.state.fandianCar.customerName.join(',')+"，船名："+shipName+"，付款总金额为："+ parseFloat(Math.abs(payment).toFixed(2))
      this.$refs.processDrawer.doInit()
    },
    setSubmitButtonEnable() {
      // 该功能暂时弃用，代码先不删
      if (true) {
        this.submitButtonEnable = true
        return
      }
      let arr = this.tabledata111.filter(item => item.checked)
      if (arr.length === 0) {
        this.submitButtonEnable = false
        return
      }
      // 为了兼容2022年9月份以前的数据没有合同的情况
      this.submitButtonEnable = arr
        .every(item => (item.contractId && item.contractSpStatus && item.contractSpStatus === 2) || this.isBefore202209(item.epartureTimeDate))
    },
    /**
     * 判断是否为2022年9月份以前的数据
     * @param date
     */
    isBefore202209(date) {
      if (!date) {
        return false
      }
      return dayjs(date).isBefore(dayjs('2022-09'))
    },
    getContractIds() {
      if (true) {
        return []
      }
      let arr = this.tabledata111.filter(item => item.checked)
      if (arr.length === 0) {
        return []
      }
      return [...new Set(arr.filter(item => item.contractId).map(item => item.contractId))]
    },
    applyVerify(){
      // TODO 校验所选的费用是否全部都是合同审批通过的
      this.setSubmitButtonEnable()
      if (!this.submitButtonEnable) {
        this.msgInfo('所选费用有合同未审批过的，审批通过方可继续')
        return
      }
      let contractIds = this.getContractIds()
      // if (contractIds.length === 0) {
      //   this.msgInfo('所选费用有合同未审批过的，审批通过方可继续')
      //   return
      // }
      if(this.applicationForm.payment <= 0){
        this.$message({
          showClose: true,
          type: 'error',
          message: '请至少选择一个航次结算'
        });
        return;
      }
      if(!this.applicationForm.contractId){
        this.$message({
          showClose: true,
          type: 'error',
          message: '请选择收款账户'
        });
        return
      }
      if (this.applicationForm.accountingType == -1) {
        this.$message({
          showClose: true,
          type: 'error',
          message: '山东公司和成功公司不能同时结算'
        });
        return
      }
      this.applicationForm.deductPrice = null
      this.applyObj = {
        application:this.applicationForm,
        applylist:this.applyData,
        deductList:this.applyDeductData,
        contractIds: contractIds.join(','),
        modelCode: 'fandian'
      }
      var shipName = this.applyData.map(item=>item.shipName).filter(function(item,index,arr){
        return arr.indexOf(item, 0) === index;
      }).join();
      this.$refs.processDrawer.title = '业务成本付款审批'
      this.$refs.processDrawer.drawer = true
      this.$nextTick(function () {
        this.$refs.paymentApprove.getData()
      })
      var payment = Number(this.applicationForm.payment)+Number(this.applicationForm.additionalPrice)
      this.$refs.processDrawer.processCode = "paymentApprove"
      this.$refs.processDrawer.globalParams = {}
      this.$refs.processDrawer.globalParams.params2 = this.applyDataIds.toString()
      this.$refs.processDrawer.globalParams.params3 = parseFloat(Math.abs(payment).toFixed(2))
      this.$refs.processDrawer.globalParams.params4 = "1456194134325854211"
      this.$refs.processDrawer.globalParams.params5 = this.applicationForm.oneCustomerName
      this.$refs.processDrawer.globalParams.params6 = this.applicationForm.customerName
      this.$refs.processDrawer.globalParams.params7 = 'fandian'
      this.$refs.processDrawer.globalParams.params9 = contractIds.join(',')
      this.$refs.processDrawer.processName = "业务成本付款申请"
      this.$refs.processDrawer.briefContent = "收款公司："+this.applicationForm.customerName+"，船名："+shipName+"，付款总金额为："+ parseFloat(Math.abs(payment).toFixed(2))
      this.$refs.processDrawer.doInit()
    },
    checkRow(row, column, event){

      //lijl 这里特殊判断，放开这个权限后不需要验证 feat_1065
      if(
        // row.id == '9d0a75a6b67042beb1088fc6ea243226' //宝迪隆6
        // || row.id == 'cc329e9966eb40f2a90996009dc38c1f' || row.id == 'b6df674de25945c0a5b36acf3c8a1d97' || row.id == 'aa74eb4fce834c70adf41488d75e28a3' //翔益和 3条
        // || row.id == 'c45109d4a42144f193b578450831e9b3' || row.id == 'b57453ca284543238a88ac187a692659' || row.id == 'aafb98a887104e908c42f5fff8f01f2d' || row.id == '2e4af78113ff4557beae14ea716e5dd3' || row.id == '164784a816334ee5b07b3c8f92113a6f' //国翔6
        // || row.id == '773bfd315e6344a0bad02964c3396bff'||
        row.id == '078f0fbf8a7440b2af1ce67356f0a800' || row.id == '267af51067874db1ae1ed8daa356abad' || row.id == '5d40d6c9dfbe490db0a910387846a158' || //德邻启航 2023/12/22 3条
        row.id == 'ab4476f8a3c34fa99ed154e49d5b6f52' || row.id == '4e281f0291064495be1ba450617fdf2e' || row.id == '0cdc8026ae3e456aba26b1530e2bbeac'  || //新鹭盛8 2023/11/28 3条
        row.id == 'd63d57db4fae45e89ba49501e2cb8f08' || row.id == '45b653e0d63544c7b8699e4dea1085f7' //合盛鑫顺 2023/12/07 2条
      ){

      }else {
        if (row.hyfSurplus > 10) {
          this.$nextTick(() => {
            row.shakeHyf = true;
            row.hyfSurplus += 0.00001;  // 不改一下这个值，不抖动
            setTimeout(() => {
              row.shakeHyf = false;
              row.hyfSurplus -= 0.00001;
            }, 820);
          })

          return;
        }
      }
      if(column != undefined){
        if(this.applicationForm.isQueren == 0){
          if(column.label != "结算金额" && column.label != "运费抵扣" ){
            if(Number(row.contractCompany) == Number(this.applicationForm.invoiceCompany)){
              if(row.checked == false){
                row.checked = true
                if(row.settleAmount == null || row.settleAmount == 0 || row.settleAmount == ''){
                  row.settleAmount = row.surplus
                  row.charge = row.surplus - row.settleAmount
                }
              } else {
                row.checked = false
                row.settleAmount = 0
                row.charge = row.surplus
              }
              this.applyData =[]
              this.applyDataIds = []
              this.applicationForm.payment = 0
              // 类型 0 成功 1 山东 2 都有
              // let accountingTypes = 0
              let accountingTypes = new Set();
              for(var i=0;i<this.tabledata111.length;i++){
                if(this.tabledata111[i].checked){
                  this.applyData.push(this.tabledata111[i])
                  this.applyDataIds.push(this.tabledata111[i].id)
                  this.applicationForm.payment += Number(this.tabledata111[i].settleAmount.toFixed(2))

                  accountingTypes.add(this.tabledata111[i].accountingType)
                }
              }
              // 类型 0 成功(默认) 1 山东 2 都有
              // 2 不能和其他一起出现
              this.applicationForm.accountingType =   accountingTypes.size > 1 && accountingTypes.has(1) ? -1 : accountingTypes.values().next().value

              this.applicationForm.payment = parseFloat(Math.abs(this.applicationForm.payment).toFixed(2))
              // this.applicationForm.accountingType = accountingTypes
              this.setSubmitButtonEnable()
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: '该航次的合同公司与选择的开票公司不一致，无法选择'
              });
            }
          }
        }
      }
    },
    setColumnClassName({row, column, rowIndex, columnIndex}){
      if(this.applicationForm.isQueren == 0 && (column.label == "结算单价" || column.label == "结算金额" || (column.label == "运费抵扣" && row.billTax =="不开" && row.checked))){
        return 'colum-class'
      }
      return '';
    },
    calcAmount(value, row) {
      var p = Number(row.surplus) - Number(row.settleAmount)
      row.charge = p > 0 ? p : 0
      if (value > 0) {
        row.checked = true
      } else {
        row.checked = false
      }
      this.applyData = []
      this.applyDataIds = []
      this.applicationForm.payment = 0
      for (var i = 0; i < this.tabledata111.length; i++) {
        if (this.tabledata111[i].checked) {
          this.applyData.push(this.tabledata111[i])
          this.applyDataIds.push(this.tabledata111[i].id)
          this.applicationForm.payment += Number(this.tabledata111[i].settleAmount.toFixed(2))
        }
      }
      this.applicationForm.payment = parseFloat(Math.abs(this.applicationForm.payment).toFixed(2))
    },
    showMsg(row, column, cell, event){


      if(
        // row.id == '9d0a75a6b67042beb1088fc6ea243226' //宝迪隆6
        // || row.id == 'cc329e9966eb40f2a90996009dc38c1f' || row.id == 'b6df674de25945c0a5b36acf3c8a1d97' || row.id == 'aa74eb4fce834c70adf41488d75e28a3' //翔益和 3条
        // || row.id == 'c45109d4a42144f193b578450831e9b3' || row.id == 'b57453ca284543238a88ac187a692659' || row.id == 'aafb98a887104e908c42f5fff8f01f2d' || row.id == '2e4af78113ff4557beae14ea716e5dd3' || row.id == '164784a816334ee5b07b3c8f92113a6f' //国翔6
        // || row.id == '773bfd315e6344a0bad02964c3396bff'||
        row.id == '078f0fbf8a7440b2af1ce67356f0a800' || row.id == '267af51067874db1ae1ed8daa356abad' || row.id == '5d40d6c9dfbe490db0a910387846a158' || //德邻启航 2023/12/22 3条
        row.id == 'ab4476f8a3c34fa99ed154e49d5b6f52' || row.id == '4e281f0291064495be1ba450617fdf2e' || row.id == '0cdc8026ae3e456aba26b1530e2bbeac'  || //新鹭盛8 2023/11/28 3条
        row.id == 'd63d57db4fae45e89ba49501e2cb8f08' || row.id == '45b653e0d63544c7b8699e4dea1085f7' //合盛鑫顺 2023/12/07 2条
      ){
      }else {
        if (row.hyfSurplus > 10) {
          this.$nextTick(() =>{
            row.shakeHyf = true;
            row.hyfSurplus += 0.00001;  // 不改一下这个值，不抖动
            setTimeout(() => {
              row.shakeHyf = false;
              row.hyfSurplus -= 0.00001;
            }, 820);
          })
          return;
        }
      }


      if(this.applicationForm.isQueren == 0) {
        if (column.label == "结算金额") {
          if (Number(row.contractCompany) == Number(this.applicationForm.invoiceCompany)) {
            this.$prompt('请输入结算金额', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              inputValue:this.NumFmt2(null,null,row.settleAmount,null)
            }).then(({value}) => {
              if (isNaN(value)) {
                this.$message({
                  showClose: true,
                  type: 'error',
                  message: '只允许输入数字'
                });
              } else {
                row.settleAmount = Number(value)
                this.calcAmount(value, row)
              }
            }).catch(() => {
              this.$message({
                showClose: true,
                type: 'info',
                message: '取消输入'
              });
            });
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: '该航次的合同公司与选择的开票公司不一致，无法选择'
            });
          }
        } else if (column.label == "结算单价") {
          if (Number(row.contractCompany) == Number(this.applicationForm.invoiceCompany)) {
            this.$prompt('请输入结算单价', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              inputValue:this.NumFmt2(null,null,row.priceSettlement,null)
            }).then(({value}) => {
              if (isNaN(value)) {
                this.$message({
                  showClose: true,
                  type: 'error',
                  message: '只允许输入数字'
                });
              } else {
                row.priceSettlement = Number(value)
                row.settleAmount = row.priceSettlement * row.settleTonnage
                this.calcAmount(value, row)
              }
            }).catch((e) => {
              console.error(e);
              this.$message({
                showClose: true,
                type: 'info',
                message: '取消输入'
              });
            });
          } else {
            this.$message({
              showClose: true,
              type: 'error',
              message: '该航次的合同公司与选择的开票公司不一致，无法选择'
            });
          }
        }
      }
    },
    ApplyhandleClose(){
      // var that = this
      this.showApply = false
    },
    getBankInfo() {
      if (this.lxrlist && this.lxrlist.length && this.applicationForm && this.applicationForm.contractId) {
        const bankInfo = this.lxrlist.find(item => item.id == this.applicationForm.contractId)
        if (bankInfo && Object.keys(bankInfo).length) {
          return {
            // accountName cardNumber
            // city openingBank province
            bak_full_name: bankInfo.accountName || '',
            bak_bank_name: bankInfo.openingBank || '',
            bak_bank_number: bankInfo.cardNumber || '',
            bak_address_province: bankInfo.province || '',
            bak_address_city: bankInfo.city || '',

          }
        }
      }
      return {
        bak_full_name: '',
        bak_bank_name: '',
        bak_bank_number: '',
        bak_address_province: '',
        bak_address_city:'',
      }
    },
    onBeforeSubmit(cb){
      let flag = true
      var outData = this.$refs.paymentApprove.getComponentsSendData()
      var companySpare = null;
      for(var i=0;i<this.dictionaryLists["contract_company"].length;i++){
        var tmp = this.dictionaryLists["contract_company"][i]
        if(tmp.code == this.applicationForm.invoiceCompany){
          companySpare = tmp.spare4
        }
      }
      console.info(companySpare)
      this.$refs.processDrawer.formValue = {
        money:this.applicationForm.payment,
        company:companySpare,
        accountId:null,
        hasInvoice: 0,
        accountingType: this.applicationForm.accountingType,
        shipGoodsMode: 2,
        payType:'fandian',
        ...this.getBankInfo()
      }
      if(!outData.checkedSettlement || outData.checkedSettlement.length<=0){
        this.msgInfo('请选择付款方式')
        flag = false
      }
      cb(flag)
    },
    getSpId(id,nopageId){
      console.log('审批成功，实例ID：' + id + ", 无纸化Id：" + nopageId);
      this.showApply = false
      this.applicationForm.source = "goodsCost"
      console.info(this.applicationForm)
      this.applyData.forEach(item => {
        item.priceWithTax = item.priceSettlement
      });

      var data = {
        application:JSON.parse(JSON.stringify(this.applicationForm)),
        applylist:this.applyData,
        processId:id,
        nopageId:nopageId,
        outData:this.$refs.paymentApprove.getComponentsSendData(),
        applyDeduct:this.applyDeductData,
      }

      // 购物车数据就是当前数据（说明使用购物车进行合并付款，有时候是购物车里有东西，但不是用的购物车结算）
      var datastr = JSON.stringify(data)
      var datajson =  encodeURIComponent(datastr)
      var querydata = {
        datajson:datajson
      }
      savePayment(querydata).then(res =>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          // 购物车数据就是当前数据（说明使用购物车进行合并付款，有时候是购物车里有东西，但不是用的购物车结算）
          if (this.$store.getters.fandianCar.goods == this.applyData) {
            // clear 清空
            this.$store.commit('clearFandianCar')
          }
        }
      }).finally(() =>{
        this.onQuery()
      })
    },
    getLxrList(id){
      getPersonalListById(id).then(res=>{
        if (res!=null&&res.resultCode === ERR_OK) {
          this.lxrlist = res.list
        }
      })
    },
    viewLxrRow(id){
      this.isshowLxr = true
      this.getLxrList(id)
    },
    handleCloseLxr(){
      this.isshowLxr = false
    },
    openShowApply(item){
      this.submitButtonEnable = false
      this.showApply = true
      this.shipPayShipOwner = null;
      this.applicationForm = {
        sysSupplierId:item.id,
        secondId:item.customerId,
        payment:null,
        remark:null,
        amountPayable:null,
        price:null,
        advanceBalance:null,
        invoiceCompany:this.queryForm.invoiceCompany,
        additionalPrice:null,
        additionalRemark:null,
        isQueren:0,
        routeName: this.$router.currentRoute.name,
        contractId:null,
        customerName:item.customerName,
        oneCustomerName: item.oneCustomerName,
        priceBatch:null,
        oneId:item.oneId,
      }
      this.getLxrList(item.customerId)
      this.getTableData111()
      this.applyData =[]
      this.applyDataIds = []
      this.costAggId = null
    },
    getTableData111(){
      this.applicationForm.amountPayable = 0
      this.tableLoading2 = true
      this.tabledata111 =[]
      var querydata = {
        cusSupId:this.applicationForm.sysSupplierId,
        invoiceCompany:this.applicationForm.invoiceCompany,
        costProject:this.queryForm.paymentTypeName,
        routeName:this.$router.currentRoute.name,
        shipPayShipOwner:this.shipPayShipOwner,
        isQueren:this.applicationForm.isQueren,
        shipName:this.queryForm.shipName,
        secondId:this.applicationForm.secondId,
        oneId: this.applicationForm.oneId,
      }
      getPaymentfandianListById(querydata).then(res =>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.tabledata111 = res.list
          if (this.tabledata111 && this.tabledata111.length > 0) {
            this.tabledata111.forEach(item => {item.priceSettlement = item.priceWithTax; item.shakeHyf = false})
          }
          console.info(this.tabledata111)
          // for(var i=0;i<res.list.length;i++){
          //   if((res.list[i].leftOver!=null && res.list[i].leftOver != 0)  || (res.list[i].arrearsAmount != null && res.list[i].arrearsAmount != 0)){
          //     this.tabledata111.push(res.list[i])
          //   }
          // }
          for(var i=0;i<this.tabledata111.length;i++){
            this.applicationForm.amountPayable += Number(this.tabledata111[i].surplus)
            this.tabledata111[i].checked = false
          }
          this.applicationForm.amountPayable = parseFloat(Math.abs(this.applicationForm.amountPayable).toFixed(2))
        }
      }).finally(()=>{
        this.tableLoading2 = false
      })
    },
    eventPage(e){
      this.pageNo = e
      this.topage();
    },
    onQuery(){
      this.topage(function () {

      });
    },
    topage(callback){
      this.tableLoading = true
      var querydata = {
        accountType: this.queryForm.accountType,
        name:this.queryForm.simpleName,
        billType:this.queryForm.billType,
        shipName:this.queryForm.shipName,
        invoiceCompany:this.queryForm.invoiceCompany,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      getPaymentListfandian(querydata).then(res=>{
        if (res!=undefined&&res.resultCode === ERR_OK) {
          this.tableData = res.page.records
          this.total = res.page.total
        }
      }).finally(()=>{
        if(callback){
          callback
        }
        this.tableLoading = false
      })
    },
    // selectTypeIn(item){
    //   if(this.applicationForm.paymentType == item.code){
    //     this.applicationForm.paymentType=null
    //     this.paymentTypeName = null
    //   } else {
    //     this.applicationForm.paymentType = item.code
    //     this.paymentTypeName = item.value
    //   }
    //   this.getTableData111()
    // },
    selectBillTypeIn(item){
      this.queryForm.billType =item
      this.getTableData111()
    },
    leixingaddIn(item){
      this.applicationForm.invoiceCompany = item.code
      this.getTableData111()
    },
    selectType(item){
      if(this.queryForm.paymentType == item.code){
        this.queryForm.paymentType=null
        this.queryForm.paymentTypeName = null
        this.paymentTypeName = null
      } else {
        this.queryForm.paymentType = item.code
        this.queryForm.paymentTypeName = item.value
        this.paymentTypeName = item.value
      }
      this.onQuery()
    },
    selectBillType(item){
      this.queryForm.billType =item
      this.onQuery()
    },
    selectQueren(item){
      this.applicationForm.isQueren = item
      this.applicationForm.payment = null
      this.getTableData111()
    },
    leixingadd(item){
      this.queryForm.invoiceCompany = item.code
      this.onQuery()
    },
    publicFmt(row,column,cellValue,index){
      var v = '--'
      if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
        v = cellValue
      }
      return v
    },
    myFmtDateTime(cellValue,fmtstr){
      if(cellValue==undefined||cellValue==null||cellValue==''){
        return '--'
      }
      return dayjs(cellValue).format(fmtstr)
    },
    NumFmt(row,column,cellValue,index){
      var v = 0
      if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
        v = parseFloat(Math.abs(cellValue).toFixed(2)) && parseFloat(Math.abs(cellValue).toFixed(2)).toString().replace(/(^|\s)\d+/g, (m) => m.replace(/(?=(?!\b)(\d{3})+$)/g, ','))
      }
      return v
    },
    NumFmt2(row,column,cellValue,index){
      var v = 0
      if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
        v = parseFloat(Math.abs(cellValue).toFixed(2))
      }
      return v
    },
    NumFmt3(row,column,cellValue,index){
      var v = 0
      if(cellValue!=undefined&&cellValue!=null&&cellValue!=''){
        v = parseFloat(Math.abs(cellValue).toFixed(3))
      }
      return v
    },
    costTypeFmt(row,column,cellValue,index){
      return fmtDictionary(cellValue,this.newdictionaryLists);
    },
    contractCompanyFmt(row,column,cellValue,index){
      return fmtDictionary(cellValue,this.contractCompanyList);
    },
    costProjecttax(row, column, cellValue, index) {
      return fmtDictionary(cellValue, this.dictionaryLists['bill_tax']);
    },
    companyFmt(row,column,cellValue,index){
      return fmtDictionary(cellValue,this.dictionaryLists['contract_company']);
    },
  },
  computed: {},
  components: {WorkFlowComponent,SimplePanelSelection,PaymentApprove,PanelSimpleSelection}
}
</script>

<style scoped>
.query-form{
  text-align: left;
  padding-top: 10px;
}
.sp_add_left{
  width: 45%;
  margin-right: 5%;
}
.sp_add_right{
  width: 45%;
}
.el-table-info >>> .cell{
  text-align: center;
}
.el-table-info >>> th {
  background: #EDF5FF;
}
.mytable td  {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.mytable td .cell {
  padding-left: 0.1rem;
  padding-right: 0.1rem;
}
.el-table-info >>> .warning-cell{
  color: red;
}
.el-table-info >>> .success-cell{
  color: #6DD400;
}
.myStep >>>.el-step__main{
  margin-top: 10px;
}
.myform >>> .el-form-item{
  margin-right: 20px;
  margin-bottom: 10px;
}
.showTitle{
  line-height: 20px;
}
.showValue{
  line-height: 20px;
  color: #2cb7fd;
}
.change-color{
  color: #F56C6C;
}
.change-gray{
  color: #909399;
}
.xuanxiang >>> .el-dialog__body{
  padding: 0px !important;
}

.checkDeduct{
  text-align: left;
  margin-bottom: 10px;
}

.title{
  margin-left: 5%;
  padding: 15px 0;
  font-size: 1.2rem;
  font-weight: 500;
}
.el-table-info >>> .colum-class {
  color: #2cb7fd;
}
.el-table-info >>> .colum-class-false {
  color: #C0C4CC;
}
.settle-detail{
  width: 50%;
  margin-left: 45%;
}
.settle-detail-item{
  display: flex;
  width: 100%;
  font-size: 1.1rem;
  line-height: 20px;
  padding: 5px 0;
}
.settle-detail-item-title{
  width: 80%;
  text-align: right;
}
.settle-detail-item-val{
  width: 20%;
  text-align: center;
}
.fengexian{
  border-bottom: 1px solid #909399;
  width: 80%;
  margin-left: 20%;
  padding: 5px 0;
  margin-bottom: 5px;
}
.showpic{
  display: none;
}
.input-box1{
  width: 100%;
  display:flex;
}
.car-accountinfo {
  margin-top:18px;
}
.car-accountinfo >>> .el-descriptions__header {
  margin-bottom: 8px;
}
.car-dialog >>> .el-dialog__body{
  padding-top: 0px;
}
</style>
